import api from './api';
import { endpoints } from './endpoints';

function ensureRegionsList(res) {
  if (!res || typeof res !== 'object') return [];
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.data?.data)) return res.data.data;
  if (Array.isArray(res.regions)) return res.regions;
  if (Array.isArray(res.data?.regions)) return res.data.regions;
  if (Array.isArray(res)) return res;
  return [];
}

function ensureDistrictsList(res) {
  if (!res || typeof res !== 'object') return [];
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.data?.data)) return res.data.data;
  if (Array.isArray(res.data?.items)) return res.data.items;
  if (Array.isArray(res.data?.districts)) return res.data.districts;
  if (Array.isArray(res.districts)) return res.districts;
  if (Array.isArray(res.items)) return res.items;
  if (Array.isArray(res.result)) return res.result;
  if (Array.isArray(res)) return res;
  return [];
}

function normalizeRegion(raw) {
  if (!raw) return null;
  const name = raw.display_name ?? raw.name_uz ?? raw.name_ru ?? raw.name_oz ?? raw.name ?? raw.name_key ?? (raw.code ? String(raw.code) : '') ?? '';
  return {
    id: raw.id ?? raw,
    name: name || String(raw.id ?? raw.code ?? ''),
    name_uz: raw.name_uz ?? null,
    name_ru: raw.name_ru ?? null,
    nameKey: raw.name_key ?? raw.nameKey ?? (raw.code ? `region_${String(raw.code).toLowerCase().replace(/\s+/g, '_')}` : null),
    code: raw.code ?? (typeof raw.id !== 'undefined' ? String(raw.id) : null),
    districts: Array.isArray(raw.districts) ? raw.districts.map(normalizeDistrict) : undefined,
  };
}

function normalizeDistrict(raw) {
  if (!raw) return null;
  const name = raw.display_name ?? raw.name_uz ?? raw.name_ru ?? raw.name_oz ?? raw.name ?? raw.name_key ?? (raw.code ? String(raw.code) : '') ?? '';
  return {
    id: raw.id ?? raw,
    regionId: raw.region_id ?? raw.regionId ?? null,
    name: name || String(raw.id ?? raw.code ?? ''),
    name_uz: raw.name_uz ?? null,
    name_ru: raw.name_ru ?? null,
    nameKey: raw.name_key ?? raw.nameKey ?? (raw.code ? `district_${String(raw.code).toLowerCase()}` : null),
    code: raw.code ?? (typeof raw.id !== 'undefined' ? String(raw.id) : null),
  };
}

export async function getRegions(params = {}) {
  const mergedParams = { with_districts: true, ...params };
  const res = await api.get(endpoints.regions, { params: mergedParams });
  const list = ensureRegionsList(res);
  return list.map(normalizeRegion).filter((x) => x && (x.name || x.code || x.id != null));
}

export async function getDistricts(regionId) {
  if (!regionId) return [];
  let list = [];
  try {
    const params = { region_id: regionId };
    const res = await api.get(endpoints.districts, { params });
    list = ensureDistrictsList(res);
  } catch {
    list = [];
  }
  if (list.length === 0) {
    try {
      const path = endpoints.districtsByRegion ? endpoints.districtsByRegion(regionId) : null;
      if (path) {
        const res = await api.get(path);
        list = ensureDistrictsList(res);
      }
    } catch {
      list = [];
    }
  }
  return list.map(normalizeDistrict).filter((x) => x && (x.name || x.code || x.id != null));
}
